import { Controller } from "@hotwired/stimulus";
import DataTable from "datatables.net-bs";
import "datatables.net-bs/css/dataTables.bootstrap.min.css";
import "datatables.net-columncontrol-dt";
import "datatables.net-columncontrol-dt/css/columnControl.dataTables.min.css";

export default class extends Controller {
  connect() {
    console.log("DataTablesController connected");
    this.initializeDataTable();
  }

  initializeDataTable() {
    const tableElement = this.element.querySelector("table");
    if (!tableElement) {
      console.error("No table element found");
      return;
    }

    const columnDefs = this.buildColumnDefs(tableElement);

    this.table = new DataTable(tableElement, {
      ordering: true,
      searching: true,
      paging: false,
      info: false,
      serverSide: false,
      language: {
        emptyTable: "No records found.",
        zeroRecords: "No matching records found.",
      },
      columnDefs: columnDefs,
      order: [[0, "asc"]],
    });

    const globalSearchInput = this.element.querySelector(".dt-search input");
    if (globalSearchInput) {
      globalSearchInput.style.border = "1px solid #ccc";
    }

    // Add clear button next to global search
    const dtSearchWrapper = this.element.querySelector(".dt-search");
    if (dtSearchWrapper) {
      const existingButton = dtSearchWrapper.querySelector(
        "[data-action*='clearAllFilters']",
      );
      if (!existingButton) {
        const clearButton = document.createElement("button");
        clearButton.type = "button";
        clearButton.className =
          "px-4 py-2 bg-red-600 text-white text-sm font-medium rounded hover:bg-red-700 ml-2";
        clearButton.textContent = "Clear All Filters";
        clearButton.setAttribute(
          "data-action",
          "click->datatables#clearAllFilters",
        );

        dtSearchWrapper.style.display = "flex";
        dtSearchWrapper.style.alignItems = "center";
        dtSearchWrapper.style.gap = "8px";

        dtSearchWrapper.appendChild(clearButton);
        this.element.addEventListener("click", (e) => {
          if (e.target === clearButton) {
            this.clearAllFilters(e);
          }
        });
      }
    }
  }

  buildColumnDefs(tableElement) {
    const headers = tableElement.querySelectorAll("thead th");
    const columnDefs = [];

    headers.forEach((th, index) => {
      const filterType = th.getAttribute("data-filter");

      if (filterType === "search") {
        columnDefs.push({
          targets: index,
          columnControl: { target: 1, content: ["search"] },
        });
      } else if (filterType === "searchList") {
        columnDefs.push({
          targets: index,
          columnControl: { target: 1, content: [["searchList"]] },
        });
      } else if (filterType === "sort") {
        columnDefs.push({
          targets: index,
          orderable: true,
          searchable: false,
          columnControl: false,
        });
      } else {
        // "none" or no attribute — no filter, not sortable/searchable (action columns)
        columnDefs.push({
          targets: index,
          orderable: false,
          searchable: false,
          columnControl: false,
        });
      }
    });

    return columnDefs;
  }

  clearAllFilters(event) {
    if (event) {
      event.preventDefault();
    }

    const globalSearchInput = this.element.querySelector(".dt-search input");
    if (globalSearchInput) {
      globalSearchInput.value = "";
    }

    // Clear ColumnControl search inputs
    const columnSearchInputs =
      this.element.querySelectorAll(".dtcc-search input");
    columnSearchInputs.forEach((input) => {
      input.value = "";
      input.dispatchEvent(new Event("input", { bubbles: true }));
    });

    if (this.table) {
      this.table.search("").columns().search("").draw();
    }
  }

  disconnect() {
    if (this.table) {
      this.table.destroy();
    }
  }
}
